export default __webpack_public_path__ + "static/media/SmartSkills.ae40e4ec.png";